export const DATE_RANGE_FORMAT = 'D MMM YYYY';
export const NO_START = '0001-01-01T00:00:00Z';
export const NO_END = '9999-12-31T00:00:00Z';
export const NO_END_DATE = '9999-12-31';
export const WEEK_IN_MS = 7 * 24 * 60 * 60 * 1000;
